module.exports = __webpack_public_path__ + "img/process_01_m.2515a118.png";